import React from 'react'
import Classes from '../../Settings.module.css'

export default function Sidebar({ activeTab, setActiveTab }) {
    return (
        <ul className={Classes.sidebar} >
            <li className={activeTab === "profile" ? Classes.active : ""}
                onClick={() => setActiveTab("profile")}>
                <h5>Profile</h5>
            </li>

            <li>
                <h5>Billing</h5>
            </li>

            <li>
                <h5>Sign out</h5>
            </li>
        </ul>
    )
}
